import { useTranslation } from 'react-i18next';

import { ContactGroupType } from 'contacts/enums';
import { IContact } from 'contacts/types';
import { SlidingPanel, Tabs } from 'core/components';
import { LabeledValue } from 'core/elements';
import { formatDate } from 'core/utils';
import { TAB_FULL_WIDTH } from 'theme/constants';

import { Information } from './Information';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  contact: IContact | null;
  contactGroupType: ContactGroupType;
  onEditContactSuccess?: (contact: IContact) => void;
}

export const ContactDetails = ({
  isOpen,
  onClose,
  contact,
  contactGroupType,
  onEditContactSuccess,
}: IProps) => {
  const { t } = useTranslation();

  const tabs = [
    {
      value: 'information',
      label: t('labelInformation'),
      content: (
        <Information
          contact={contact}
          contactGroupType={contactGroupType}
          onEditContactSuccess={onEditContactSuccess}
        />
      ),
      style: baseInformationTabWrapperStyle,
    },
  ];

  return (
    <SlidingPanel
      isOpen={isOpen}
      onClosePanel={onClose}
      title={t('titleContactDetailsWithName', { name: contact?.name })}
      subtitle={
        <LabeledValue
          label={t('labelLastUpdated')}
          value={formatDate(contact?.updatedAt)}
          options={{ inline: true }}
        />
      }
      autoWidth
      interactive
      level={1}
    >
      <Tabs tabs={tabs} ariaLabel={'contactDetails'} />
    </SlidingPanel>
  );
};

const baseInformationTabWrapperStyle = {
  ['@media (min-width: 720px)']: {
    width: 636,
  },

  ['@media (max-width: 720px)']: {
    width: TAB_FULL_WIDTH,
  },
};
